/* eslint-disable no-nested-ternary */
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { TableRow, TableCell } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import {
  getSiteReportsBySiteId,
  changeReportDate,
} from '../../redux/actions/sites';
import { CommonButton } from '../../CommonComponents';

const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 25,
    borderRadius: 15,
  },
  colorPrimary: {
    backgroundColor: '#E2BEE8',
  },
  bar: {
    borderRadius: 15,
    backgroundColor: '#9C27B0',
  },
}))(LinearProgress);

const SiteAssignRow = ({
  row,
  handleApprovedViewDetails,
}) => (
  <>
    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
      <TableCell />
      <TableCell className="pl-0">
        {moment(row.newStartDate ? row.newStartDate : row.startDate).format(
          'DD MMM YYYY',
        )}
        {' '}
        to
        {' '}
        {moment(row.newEndDate ? row.newEndDate : row.endDate).format('DD MMM YYYY')}
      </TableCell>
      <TableCell>{row.mediaTypeName}</TableCell>
      <TableCell>{row.monitor}</TableCell>
      <TableCell>{row.cityName}</TableCell>
      <TableCell>{row.locationName}</TableCell>
      <TableCell style={{ paddingLeft: 0 }}>
        <Box display="block" alignItems="center">
          {row.onetSD
            ? (
              <Box display="flex" justifyContent="center">
                {`SD: ${row.onetSD}`}
              </Box>
            )
            : null}
          <Box width="100%" className="position-relative">
            <BorderLinearProgress
              variant="determinate"
              value={
                  row.totalReports > 0
                    ? Math.round(
                      (row.submittedReports / row.totalReports) * 100,
                    )
                    : 0
                }
            />
            {row.submittedReports > 0 && (
            <Typography
              variant="body2"
              style={{
                position: 'absolute',
                right: '1px',
                top: '4px',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '14px',
              }}
            >
              {`${Math.round(
                (row.submittedReports / row.totalReports) * 100,
              )}%`}
            </Typography>
            )}
          </Box>
          {row.onetED
            ? (
              <Box display="flex" justifyContent="center">
                {`ED: ${row.onetED}`}
              </Box>
            )
            : null}
        </Box>
      </TableCell>
      <TableCell>
        {row.submittedReports}
        /
        {row.totalReports}
      </TableCell>
      <TableCell>
        <CommonButton
          onClick={() => handleApprovedViewDetails(row)}
          basic="true"
          color="primary"
        >
          <b>View Images</b>
        </CommonButton>
        {' '}
      </TableCell>
    </TableRow>

  </>
);

const mapActions = {
  getSiteReports: getSiteReportsBySiteId,
  changeDate: changeReportDate,
};

export default connect(null, mapActions)(SiteAssignRow);
